import { Suspense } from 'react';
import { Sidebar } from './sidebar';
import { cn } from '@/utils';
import { Outlet, useLocation } from 'react-router-dom';
import { SidebarProvider } from '@/components/ui/sidebar';
import { ConfirmProvider } from '@/providers/confirm';
import { HistoryTracker } from '@/features/misc/components/previous-path-link';
import { MobileSidebarTrigger } from './mobile-sidebar-trigger';

export function Layout() {
  const { pathname } = useLocation();

  return (
    <ConfirmProvider>
      <SidebarProvider>
        <HistoryTracker />

        <MobileSidebarTrigger />

        <Sidebar />
        <main className={cn('w-full max-w-full', pathname?.includes('events/manage') ? 'h-[100lvh] sm:h-screen overflow-hidden sm:pt-0 sm:pl-0' : 'min-h-screen overflow-y-auto p-2 pb-[calc(env(safe-area-inset-bottom)+56px)] sm:p-6')}>
          <Suspense fallback={<div className="h-full w-full flex items-center justify-center "></div>}>
            <Outlet />
          </Suspense>
        </main>
      </SidebarProvider>
    </ConfirmProvider>
  );
}
